// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2DH70","fileBtn":"File_fileBtn__--0J4","closeBtn":"File_closeBtn__V1mSU","fileSelected":"File_fileSelected__1SF_o","disabled":"File_disabled__24SMw"};